var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getImageSourceFromCamera, renderIcon } from '../../../utils';
import { useEffect, useState } from 'react';
import { classNames } from '../../../utils/style-class.utils';
import Typography from '../../typography/typography';
import * as styles from './image-input.styles';
export var ImageInput = function (_a) {
    var label = _a.label, subLabel = _a.subLabel, nameProp = _a.nameProp, acceptedFormats = _a.acceptedFormats, _b = _a.disabled, disabled = _b === void 0 ? false : _b, register = _a.register, _c = _a.icon, icon = _c === void 0 ? 'UploadIcon' : _c, _d = _a.iconContainerColor, iconContainerColor = _d === void 0 ? 'secondary' : _d, iconColour = _a.iconColour, className = _a.className, currentImageString = _a.currentImageString, resolutionLimit = _a.resolutionLimit, onValueChange = _a.onValueChange, overrideOnClick = _a.overrideOnClick;
    var _e = useState(''), fileName = _e[0], setFileName = _e[1];
    var _f = useState(''), error = _f[0], setError = _f[1];
    var test = register === null || register === void 0 ? void 0 : register(nameProp);
    var _g = useState(''), currentImage = _g[0], setCurrentImage = _g[1];
    var handleChange = function (event) {
        if (event && event.target && event.target.files) {
            var firstFile = event.target.files[0];
            handleFile(firstFile);
            setFileName(firstFile === null || firstFile === void 0 ? void 0 : firstFile.name);
        }
        else {
            setFileName('');
        }
    };
    useEffect(function () {
        if (currentImageString) {
            setCurrentImage(currentImageString);
        }
        else {
            setCurrentImage('');
        }
    }, [currentImageString]);
    var handleDrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
        if (event && event.dataTransfer && event.dataTransfer.files) {
            var firstFile = event.dataTransfer.files[0];
            handleFile(firstFile);
            setFileName(firstFile === null || firstFile === void 0 ? void 0 : firstFile.name);
        }
        else {
            setFileName('');
        }
    };
    var handleFile = function (file) {
        var _a;
        var fileExtension = (file === null || file === void 0 ? void 0 : file.name) ? (_a = file === null || file === void 0 ? void 0 : file.name) === null || _a === void 0 ? void 0 : _a.split('.').pop() : undefined;
        if (fileExtension) {
            if (acceptedFormats.length > 0) {
                if (acceptedFormats.filter(function (x) { return x === fileExtension; }).length > 0) {
                    setError('');
                }
                else {
                    setError('Invalid File type');
                }
            }
            else {
                setError('');
            }
        }
        else {
            setError('Invalid File type');
        }
    };
    var handleDragOver = function (event) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
    };
    var getButtonLabel = function () {
        if (error) {
            return error;
        }
        return currentImage ? 'Tap to change' : 'Tap to add';
    };
    var getContainerStyle = function () {
        if (error) {
            return styles.errorContainerStyle;
        }
        return fileName
            ? styles.fileContainerStyle
            : classNames(styles.containerStyle, "bg-white");
    };
    var getIconStyle = function () {
        if (error) {
            return styles.errorIconStyle;
        }
        return fileName ? styles.fileIconStyle : iconColour !== null && iconColour !== void 0 ? iconColour : styles.iconStyle;
    };
    var handleClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!overrideOnClick) return [3, 1];
                    overrideOnClick();
                    return [3, 3];
                case 1: return [4, getImageSourceFromCamera(resolutionLimit)
                        .then(function (imageString) {
                        setCurrentImage(imageString !== null && imageString !== void 0 ? imageString : '');
                        if (onValueChange) {
                            onValueChange(imageString !== null && imageString !== void 0 ? imageString : '');
                        }
                    })
                        .catch(function (error) { return console.error(error); })];
                case 2:
                    res = _a.sent();
                    _a.label = 3;
                case 3: return [2];
            }
        });
    }); };
    return (_jsxs("div", __assign({ className: className }, { children: [_jsx("div", { children: _jsx(Typography, { className: styles.labelStyle, weight: "bold", type: 'body', color: 'textDark', text: label }) }), _jsx("div", { children: _jsx(Typography, { className: styles.labelStyle, type: 'body', color: 'textMid', text: subLabel }) }), _jsx("div", __assign({ className: classNames(getContainerStyle(), styles.containerBaseStyle), onClick: function () {
                    handleClick();
                }, onDrop: function (e) {
                    handleDrop(e);
                }, onDragOver: function (e) {
                    handleDragOver(e);
                } }, { children: _jsxs("div", __assign({ className: styles.imageContainer, style: {
                        backgroundImage: "url(".concat(currentImage, ")"),
                    } }, { children: [_jsx("div", __assign({ className: classNames(styles.iconBaseStyle, "bg-".concat(iconContainerColor)) }, { children: renderIcon(icon, classNames(getIconStyle(), "bg-".concat(iconContainerColor))) })), _jsx(Typography, { className: "".concat(currentImage.length > 0
                                ? styles.buttonlabelStyle + " rounded bg-white"
                                : styles.buttonlabelStyle), weight: "bold", type: 'help', color: 'textMid', text: getButtonLabel() })] })) })), _jsx("input", { accept: acceptedFormats.toString(), id: nameProp, disabled: disabled, type: "file", style: { display: 'none' }, onChange: function (e) {
                    handleChange(e);
                } })] })));
};
export default ImageInput;
//# sourceMappingURL=image-input.js.map